import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { MockApiService } from '../../../mock-api.service';
import { project as projectData } from './data';

@Injectable({
    providedIn: 'root'
})
export class LandingMockApi
{
    private _project: any = projectData;

    /**
     * Constructor
     */
    constructor(private _mockApiService: MockApiService)
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
      

        // -----------------------------------------------------------------------------------------------------
        // @ Sales - GET
        // -----------------------------------------------------------------------------------------------------
        this._mockApiService
            .onGet('api/dashboards/landing')
            .reply(() => [200, cloneDeep(this._project)]);
    }
}
